import { render } from "./DescripcionCuestionario.vue?vue&type=template&id=0a33fe6a&scoped=true"
import script from "./DescripcionCuestionario.vue?vue&type=script&lang=js"
export * from "./DescripcionCuestionario.vue?vue&type=script&lang=js"

import "./DescripcionCuestionario.vue?vue&type=style&index=0&id=0a33fe6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a33fe6a"]])

export default __exports__